import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'biometric-policy-current',
  templateUrl: './biometric-policy-current.component.html',
  styleUrls: ['./biometric-policy-current.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BiometricPolicyCurrentComponent implements OnInit {
  showPhotoVerify = false;
  verification: any;
  participant = false;
  submitting = false;

  constructor() {}

  ngOnInit(): void {}

  toggle(property: string) {
    this[property] = !this[property];
  }
}
